import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-0f73cc64"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "date-picker" };
var _hoisted_2 = { class: "base-model__header base-model__header--border" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("i", {
    class: "icon icon-arrowleft icon--xs",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */); });
var _hoisted_4 = [
    _hoisted_3
];
var _hoisted_5 = { class: "base-model__header-title heading-h5" };
var _hoisted_6 = { class: "base-model__footer" };
import { computed, ref, defineAsyncComponent } from 'vue';
import { useIsMobile } from '../../hooks/useIsMobile';
import InputField from '../InputField/InputField.vue';
import DropdownContainer from '../DropdownContainer/DropdownContainer.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatePicker',
    props: {
        disabledDates: { default: function (props) { var _a; return (_a = props.disabledDates) !== null && _a !== void 0 ? _a : []; } },
        defaultValue: { default: function (props) { var _a; return (_a = props.defaultValue) !== null && _a !== void 0 ? _a : [new Date()]; } },
        minDate: { default: function (props) { return props.minDate; } },
        maxDate: { default: function (props) { return props.maxDate; } },
        range: { type: Boolean },
        name: {},
        label: { default: 'Select date' },
        placeholder: { default: '' },
        desktopMode: { default: 'single' },
        mobileMode: { default: 'single' },
        required: { type: Boolean, default: false },
        errorMessage: { default: '' }
    },
    emits: ['update:date', 'update:inputValue'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var CalendarControl = defineAsyncComponent(function () { return import(
        /* webpackChunkName: "calendarControl" */
        '../CalendarControl/CalendarControl.vue'); });
        var value = ref(props.defaultValue);
        var tempValue = ref(props.defaultValue);
        var isMobile = useIsMobile();
        var currentValue = computed(function () {
            return value.value.map(function (val) { return val === null || val === void 0 ? void 0 : val.toDateString().substring(4); }).join(' - ');
        });
        var showCalendar = ref(false);
        var onValueChange = function (newValue) {
            emit('update:date', newValue);
            if (!isMobile.value &&
                ((props.range && newValue.length === 2) ||
                    (!props.range && newValue.length === 1))) {
                value.value = newValue;
                showCalendar.value = false;
                emit('update:inputValue', { name: props.name, value: value.value });
            }
            else {
                tempValue.value = newValue;
                emit('update:inputValue', { name: props.name, value: tempValue.value });
            }
        };
        var onClose = function () {
            value.value = tempValue.value;
            showCalendar.value = false;
        };
        return function (_ctx, _cache) {
            var _a;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = function ($event) { return (showCalendar.value = true); })
                }, [
                    _createVNode(InputField, {
                        modelValue: currentValue.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((currentValue).value = $event); }),
                        "icon-right": "icon icon-calendar",
                        placeholder: _ctx.placeholder,
                        label: _ctx.label,
                        readonly: "true",
                        required: _ctx.required,
                        name: _ctx.name,
                        error: (_a = {}, _a[_ctx.name] = _ctx.errorMessage, _a),
                        onClick: _cache[1] || (_cache[1] = function ($event) { return (showCalendar.value = true); })
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "label", "required", "name", "error"])
                ]),
                _createVNode(DropdownContainer, {
                    "full-screen": _unref(isMobile),
                    open: showCalendar.value,
                    "onClick:outside": _cache[5] || (_cache[5] = function ($event) { return (showCalendar.value = false); })
                }, _createSlots({
                    default: _withCtx(function () { return [
                        _createVNode(_unref(CalendarControl), {
                            disabledDates: _ctx.disabledDates,
                            range: _ctx.range,
                            minDate: _ctx.minDate,
                            maxDate: _ctx.maxDate,
                            defaultValue: value.value,
                            mode: _unref(isMobile) ? _ctx.mobileMode : _ctx.desktopMode,
                            "onUpdate:date": onValueChange
                        }, null, 8 /* PROPS */, ["disabledDates", "range", "minDate", "maxDate", "defaultValue", "mode"])
                    ]; }),
                    _: 2 /* DYNAMIC */
                }, [
                    (_unref(isMobile))
                        ? {
                            name: "header",
                            fn: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("button", {
                                        class: "button--text button--icon base-model__header-close m-r--8",
                                        "aria-label": "Dismiss modal",
                                        role: "button",
                                        onClick: _cache[3] || (_cache[3] = function ($event) { return (showCalendar.value = false); })
                                    }, _hoisted_4),
                                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.label), 1 /* TEXT */)
                                ])
                            ]; }),
                            key: "0"
                        }
                        : undefined,
                    (_unref(isMobile))
                        ? {
                            name: "footer",
                            fn: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                        class: "button button--text",
                                        onClick: _cache[4] || (_cache[4] = function ($event) { return (showCalendar.value = false); })
                                    }, " Cancel"),
                                    _createElementVNode("button", {
                                        class: "button button--primary",
                                        onClick: onClose
                                    }, "Done")
                                ])
                            ]; }),
                            key: "1"
                        }
                        : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["full-screen", "open"])
            ]));
        };
    }
});
